import styled from 'styled-components'

const SubmitError = styled.p`
  margin: 0 24px 4px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fdecea;
  color: #b00020;
  font-size: 14px;
  line-height: 1.4;
`

export default SubmitError
